/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

function ajaxAddToCart() {
  var $form = $('.js-product-form');

  $form.on('submit', function(event) {
    event.preventDefault();

    $.ajax({
      url: $(this).attr('action'),
      type: 'POST',
      data: $(this).serialize(),
    })
      .done(function() {
        $.ajax({
          url: '/cart?view=dropdown-view',
        })
          .done(function(response) {
            var dropdownHTML = $(response)
              .find('.drawer')
              .html();

            window.theme.sections.getInstances('header-section').then(function(instances) {
              instances[0].scrollHandler = true;
            });

            $('.drawer').empty();
            $('.drawer').html(dropdownHTML);

            $('html').addClass('outline-disabled disable-scroll');
            $('body').addClass('drawer--active');
          })
          .fail(function(error) {
            alert(error.responseJSON.description);
          });
      })
      .fail(function(error) {
        alert(error.responseJSON.description);
      });
  });

  $(document).on('click', '.drawer-cover, .cart-drawer__close-button', function(event) {
    event.preventDefault();

    $('html').removeClass('outline-disabled disable-scroll');
    $('body').removeClass('drawer--active');
  });
}

function sliderText() {
  $('.js-slider-text').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
  });
}

function initAccordions() {
  var $accordion = $('.js-accordion');

  $accordion.on('click', '.js-accordion-head', function(event) {
    event.preventDefault();

    var $this = $(this);
    var toggleIsActive = $this.closest('.js-accordion').hasClass('js-accordion-toggle');

    if (toggleIsActive) {
      $this
        .next()
        .stop()
        .slideToggle(400)
        .parent()
        .toggleClass('is-expanded')
        .siblings()
        .removeClass('is-expanded')
        .find('.js-accordion-body')
        .slideUp();
    }

    if (!toggleIsActive) {
      $this
        .parent()
        .toggleClass('is-expanded')
        .siblings()
        .removeClass('is-expanded');
    }
  });
}

function initWaypoints() {
  $('.js-waypoint').on('click', function(event) {
    event.preventDefault();

    const $element = $($(this).attr('href'));

    if (!$element.length) {
      return;
    }

    $('html, body').animate(
      {
        scrollTop: $element.offset().top,
      },
      2000
    );
  });
}

ajaxAddToCart();
sliderText();
initAccordions();
initWaypoints();
